import { useState } from "react";
import {
  fetchOrganizerPavilions,
  fetchPavilionById,
  createPavilion,
  updatePavilion,
  deletePavilion as deletePavilionApi,
  fetchPavilionsTree,
} from "../../../api/pavilion.api";

export const usePavilions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pavilions, setPavilions] = useState([]);

  const loadPavilions = async (company_id) => {
    setLoading(true);
    const res = await fetchPavilionsTree({ company_id });
    setData(res.data?.data || []);
    setLoading(false);
  };

  const loadPavilionById = async (id) => {
    try {
      const res = await fetchOrganizerPavilions(id);
      setPavilions(res.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching pavilion by ID:", error);
      setPavilions([]);
    }
  };

  const addPavilion = (payload) => createPavilion(payload);
  const editPavilion = (id, payload) => updatePavilion(id, payload);
  const deletePavilion = async (id, payload) => {
     const res = await deletePavilionApi(id, payload);
        return res.data;
      };

  return {
    data,
    loading,
    pavilions,
    loadPavilions,
    loadPavilionById,
    addPavilion,
    editPavilion,
    deletePavilion,
  };
};
